<template>
  <div>
      <a class="feedback" href="https://jinshuju.net/f/H5bn5B">意见反馈</a>
  </div>
</template>

<script>
export default {
    data(){
        return{

        }
    },
    methods:{

    }
}
</script>

<style lang="scss">
.feedback{
    background-color: #ffffff;
    font-size: 24px;
    color: #333333;
    text-align: center;
    position: fixed;
    right: 0;
    bottom: 240px;
    box-shadow:0px 5px 7px 0px rgba(99,99,99,0.1);
    border-radius:35px 0px 0px 35px;
    padding: 24px 20px 24px 36px;
}
</style>